import { RETAINER_PARAMETERS } from '@witmetrics/utils/constants';
import type { RetainerFormParams } from '@witmetrics/unison-core';
import type { RetainerParameterKey } from '@witmetrics/utils';
import TabsBlock, { Tab } from '@/components/TabsBlock';
import ServiceParameter from '@/components/ServiceParameter';
import EngravementForm from '../EngravementForm';
import type { RetainerFormSection } from './types';
import { classes } from '../utils';

export type RetainerFormProps = {
  params: RetainerFormParams;
  onChange: (params: RetainerFormParams) => void;
};

export default function RetainerForm({ params, onChange }: RetainerFormProps) {
  const renderParam = (key: RetainerParameterKey) => (
    <ServiceParameter
      parameter={RETAINER_PARAMETERS[key]}
      value={params[key]}
      onChange={(update) => onChange({ ...params, ...update })}
    />
  );

  return (
    <TabsBlock<RetainerFormSection[]>
      className={classes.tabsBlock}
      bodyClassName={classes.tabsBody}
      orientation="vertical"
      name="retainer-parameters"
      defaultTab="QUICK_SETUP">
      <Tab className={classes.tab} name="QUICK_SETUP" label="Quick Setup">
        {renderParam('edgeType')}
        {renderParam('offset')}
        {renderParam('thickness')}
        {renderParam('margin')}
        {renderParam('impressionCleaning')}
        {params.impressionCleaning !== 'no_impression_cleaning' &&
          renderParam('artifactThreshold')}
        {renderParam('attachmentRemoval')}
      </Tab>
      <Tab className={classes.tab} name="ENGRAVEMENT" label="Engravement">
        <EngravementForm
          engravedText={params.engravedText}
          onChange={(engravedText) => onChange({ ...params, engravedText })}
        />
      </Tab>
      <Tab
        className={classes.tab}
        name="RETAINER_PARAMS"
        label="Retainer Settings">
        {renderParam('edgeType')}
        {renderParam('offset')}
        {renderParam('thickness')}
        {renderParam('margin')}
      </Tab>
      <Tab className={classes.tab} name="WAXING" label="Waxing">
        {renderParam('waxing')}
        {params.waxing === 'enabled' && (
          <>
            {renderParam('edentulousZones')}
            {renderParam('interproximalWaxing')}
            {renderParam('gumLineWaxing')}
            {renderParam('undercutRemoval')}
            {params.undercutRemoval === 'enabled' &&
              renderParam('undercutRetention')}
          </>
        )}
      </Tab>
      <Tab className={classes.tab} name="BASING" label="Basing">
        {renderParam('baseType')}
        {renderParam('infill')}
        {renderParam('gingivaMargin')}
        {renderParam('baseHeight')}
        {renderParam('baseChamfer')}
        {renderParam('baseChamferHeight')}
        {renderParam('drainageHoles')}
        {renderParam('baseWallThickness')}
        {renderParam('baseReinforcementType')}
      </Tab>
      <Tab className={classes.tab} name="OTHER" label="Other">
        {renderParam('impressionCleaning')}
        {params.impressionCleaning !== 'no_impression_cleaning' &&
          renderParam('artifactThreshold')}
        {renderParam('attachmentRemoval')}
      </Tab>
      <Tab className={classes.tab} name="ADVANCED" label="Advanced">
        {renderParam('orientation')}
        {renderParam('parallelizeBases')}
      </Tab>
    </TabsBlock>
  );
}
